import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Role } from '../../models/user-master/role';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class RoleProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.userMasterApi + '/api/v1/roles';

  getAllRoles(): Observable<ApiResponse<Role[]>> {
    return this.httpClient.get<ApiResponse<Role[]>>(`${this.baseUrl}/all`);
  }
}
